import VectorMapMarker from '../markers/VectorMapMarker';
import React from 'react';
import { MarkerData } from '../classes/MarkerData';
import {
  isPointContainedInBounds,
  isPointShowMultipleTimes,
  getMapsWhereIsShowPoint,
  IS_SHOW_POINT
} from './../helpers/helper';

const isMarkerContainedInBounds = (
  lat: number,
  long: number,
  mapRef: any,
  useReducerBound: boolean,
  cyclicMapPaddingWidth: number
) => {
  return isPointContainedInBounds(lat, long, mapRef, useReducerBound, cyclicMapPaddingWidth);
};

export const renderMarkersFn = ({
  fareMarkers,
  handleSetMarkerHover,
  isShowTopOffers,
  oldEndRouteMarker,
  markerHover,
  mapProps,
  mapRef,
  zIndex,
  setZIndex,
  markersSettings,
  cyclicMapPaddingWidth
}: any) => {
  // TODO: It was necessary to filter since the popup opens automatically
  //       and is positioned according to where it has available space that
  //       formerly when positioned above the fareMarker was covered and was not seen.
  return fareMarkers
    .filter((e: MarkerData) => JSON.stringify(e) !== JSON.stringify(oldEndRouteMarker))
    .map((marker: MarkerData, index: number) => {
      const basicMarkerProps: any = {
        onMouseOver: handleSetMarkerHover,
        key: `marker-${index}`,
        showTopOffers: isShowTopOffers,
        marker: marker,
        isMapMode: !!mapProps?.mapMode?.mode,
        markerHover: markerHover,
        mapRef: mapRef,
        zIndex: zIndex,
        setZIndex: setZIndex,
        ...markersSettings
      };
      const useReducerBound = isPointShowMultipleTimes(
        marker?.location[0],
        marker?.location[1],
        mapRef
      );
      const isMarkersInBounds = [
        isMarkerContainedInBounds(
          marker?.location[0],
          marker?.location[1],
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <VectorMapMarker {...basicMarkerProps} />
        ) : null,
        isMarkerContainedInBounds(
          marker?.location[0],
          marker?.location[1] - 360,
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <VectorMapMarker
            {...basicMarkerProps}
            marker={{
              ...marker,
              location: [marker?.location[0], marker?.location[1] - 360]
            }}
            key={`marker-${index}-map-1`}
          />
        ) : null,
        isMarkerContainedInBounds(
          marker?.location[0],
          marker?.location[1] + 360,
          mapRef,
          useReducerBound,
          cyclicMapPaddingWidth
        ) ? (
          <VectorMapMarker
            {...basicMarkerProps}
            marker={{
              ...marker,
              location: [marker?.location[0], marker?.location[1] + 360]
            }}
            key={`marker-${index}-map-2`}
          />
        ) : null
      ];
      for (let index = 0; index < isMarkersInBounds.length; index++) {
        if (isMarkersInBounds[index]) {
          return isMarkersInBounds[index];
        }
      }
      const mapsWhenIsShowPoint = getMapsWhereIsShowPoint(
        marker?.location[0],
        marker?.location[1],
        mapRef,
        0
      );
      if (mapsWhenIsShowPoint[0] === IS_SHOW_POINT) {
        return <VectorMapMarker {...basicMarkerProps} />;
      } else if (mapsWhenIsShowPoint[1] === IS_SHOW_POINT) {
        return (
          <VectorMapMarker
            {...basicMarkerProps}
            marker={{
              ...marker,
              location: [marker?.location[0], marker?.location[1] - 360]
            }}
            key={`marker-${index}-map-1`}
          />
        );
      } else if (mapsWhenIsShowPoint[2] === IS_SHOW_POINT) {
        return (
          <VectorMapMarker
            {...basicMarkerProps}
            marker={{
              ...marker,
              location: [marker?.location[0], marker?.location[1] + 360]
            }}
            key={`marker-${index}-map-2`}
          />
        );
      } else {
        return <VectorMapMarker {...basicMarkerProps} />;
      }
    });
};
